import { formatPrice } from '../../utils';

export const formatInputValueToPrice = (value: string) =>
	value ? Math.round((formatPrice(value) || 0) * 100) / 100 : '';
export const separateNumberStringThousands = (value: string) =>
	value.replace(/^-?\d+/g, (match) => match.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
